import { render, staticRenderFns } from "./CrmQuickReplies.vue?vue&type=template&id=4817a871&scoped=true"
import script from "./CrmQuickReplies.vue?vue&type=script&lang=js"
export * from "./CrmQuickReplies.vue?vue&type=script&lang=js"
import style0 from "./CrmQuickReplies.vue?vue&type=style&index=0&id=4817a871&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4817a871",
  null
  
)

export default component.exports